import React from 'react';
import ReactDOM from 'react-dom/client';
// No need to use; as long as it's imported, it is initialized
import './i18n';

import App from './pages/App';
import '../../../shared/styles/global.css';
import './styles/styles.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(<App />);
